import React from "react";
import PropTypes from "prop-types";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { autoCompleteSx, isEmptyOrNullStr } from '../../helpers/utils'
import { HIGHLIGHT_TYPE } from '../../configs/constants'
import CurrencyInput from 'react-currency-input-field';
import OptionItem from "../../components/OptionItem";
import classNames from "classnames";
import  IframeCard  from "../../components/IframeCard";
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Input,
  Row,
  Col
} from "reactstrap";

function mountEvent(name,value) {
  return {
    target:{
      name: name,
      value: value,
    }
  };
};

const FolderComponent = ({
  onChange,
  onClick,
  onCancel,
  onInputChangeImageContainer,
  image,
  page,
  imageContainer,
  imagesContainer,
  products,
  product,
  onInputChangeProduct,
  productIsLoading,
  imageIsLoading,
  onChangeClubValue,
  onChangeOriginalValue,
  onWebSearch,
  preview,
  onChangeIsFractioned,
  // onChangeValue,
  // onChangeName,
  // onChangeCode,
  onChangeDescription
}) => {
  return (
    <Row>
      <Col>
        <Card>
          <CardHeader>
            <h5 className="title">Cartaz</h5>
          </CardHeader>
          <CardBody>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                onClick();
              }}
            >    
              <IframeCard onRefresh={preview}/>
              <Row>
                <Col xs={12} md={6}>
                  <FormGroup>
                    <span>Dispositivo</span>
                    <Input
                      id="deviceId"
                      name="deviceId"
                      value={image?.deviceId}
                      placeholder="Dispositivo"
                      type="text"
                      disabled={true}
                    />
                  </FormGroup>
                </Col>
                <Col xs={12} md={6}>
                  <FormGroup>
                    <span>Página</span>
                    <Input
                      id="pageDescription"
                      name="pageDescription"
                      value={page?.description}
                      placeholder="Página"
                      type="text"
                      disabled={true}
                    />
                  </FormGroup>
                </Col>                                           
              </Row>
              <Row>
                <Col xs={12} md={6}>
                  <FormGroup>
                    <span>Buscar produto</span>
                    <Autocomplete
                      freeSolo
                      noOptionsText={"Nenhum"}
                      onInputChange={(event, value) =>                         
                        onInputChangeProduct(event, value)
                      }
                      loadingText={"Carregando"}
                      loading={productIsLoading}
                      style={{paddingBottom: "10px"}}   
                      id="product"
                      value={product}               
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      options={products.map((product) => product)}
                      size="small"
                      renderInput={(params) => (
                        <TextField  {...params}  variant='standard'/>
                      )}
                      sx={autoCompleteSx()}
                      renderOption={(props, option) => {
                        return (
                          <span  {...props}>
                            <Row>
                              <Col xs={12} md={12} style={{textAlign: "left"}}>
                                {option.name}
                              </Col>                              
                            </Row>
                          </span>
                        );
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col xs={12} md={6}>
                  <FormGroup>
                    <span>Código do produto</span>
                    <Input
                      name="productCode"
                      type="number"
                      placeholder="Produto"
                      value={image?.product?.code}
                      disabled={true}
                      // onChange={(e) => onChangeCode(e.target.value)}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={6}>
                  <FormGroup>
                    <span>Produto</span>
                    <Input
                      name="productName"
                      type="text"
                      placeholder="Produto"
                      value={image?.product?.name}
                      disabled={true}
                      // onChange={(e) => onChangeName(e.target.value)}
                    />
                  </FormGroup>
                </Col>
                <Col xs={12} md={6}>
                  <FormGroup>
                    <span>Preço</span> 
                      <CurrencyInput
                        id="valueStr"
                        className="form-control"
                        value={image?.product?.valueStr || ""}
                        name="valueStr"
                        decimalsLimit="2"             
                        placeholder="0,00"
                        disabled={true}
                        // onValueChange={(value) => onChangeValue(value)}
                      />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={6}>
                    <FormGroup>
                      <span>Nome do produto que vai aparecer no cartaz, se vazio apresenta o nome acima</span>
                      <Input
                        id="description"
                        name="description"
                        type="text"
                        placeholder="Ex: Morango"
                        value={image?.product?.description}
                        onChange={(e) => onChangeDescription(e.target.value)}
                      />
                  </FormGroup>
                </Col>
                <Col xs={12} md={6}>
                  <FormGroup>
                    <label>Fraciona 100Gr?</label>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Button
                        color={image?.product?.isFractioned ? "primary" : "secondary"}
                        onClick={() => onChangeIsFractioned(true)}
                        className="btn-sm"
                      >
                        Sim
                      </Button>
                      <Button
                        color={!image?.product?.isFractioned ? "primary" : "secondary"}
                        onClick={() => onChangeIsFractioned(false)}
                        className="btn-sm"
                        style={{ marginLeft: "10px" }}
                      >
                        Não
                      </Button>
                      {image?.product?.isFractioned && (
                        <Input
                          id="fractionedValue"
                          type="text"
                          className="form-control"
                          value={((Math.floor((image?.product?.value || 0) / 1000 * 100) / 100).toFixed(2)).replace('.', ',')}
                          disabled
                          style={{ marginLeft: "15px", width: "100%" }}
                          placeholder="0,00"
                        />
                      )}
                    </div>
                  </FormGroup>
                </Col>                    
              </Row>
              <Row>
                <Col xs={12} md={6}>
                  <FormGroup>
                    <span>Tipo de Destaque</span>
                    <ButtonGroup style={{ width: "100%", flexDirection: "column" }}>
                    <Button
                        color="info"
                        className={classNames("btn-simple", { active: image?.highlightType === HIGHLIGHT_TYPE.none })}
                        outline
                        style={{width: "50%"}}
                        onClick={() => onChange(mountEvent("highlightType", HIGHLIGHT_TYPE.none))}
                      >
                        Nenhum
                      </Button>  
                      <Button
                        color="info"
                        className={classNames("btn-simple", { active: image?.highlightType === HIGHLIGHT_TYPE.blink })}
                        outline
                        style={{width: "50%"}}
                        onClick={() => onChange(mountEvent("highlightType", HIGHLIGHT_TYPE.blink))}
                      >
                        Pisca
                      </Button>                       
                      <Button
                        color="info"
                        className={classNames("btn-simple", { active: image?.highlightType === HIGHLIGHT_TYPE.offer })}
                        outline
                        style={{width: "50%"}}
                        onClick={() => onChange(mountEvent("highlightType", HIGHLIGHT_TYPE.offer))}
                      >
                        Oferta
                      </Button>
                      <Button
                        color="info"
                        className={classNames("btn-simple", { active: image?.highlightType === HIGHLIGHT_TYPE.club })}
                        outline
                        style={{width: "50%"}}
                        onClick={() => onChange(mountEvent("highlightType", HIGHLIGHT_TYPE.club))}
                      >
                        Clube
                      </Button>
                    </ButtonGroup>
                  </FormGroup>
                </Col>           
                <Col xs={12} md={6}>                   
                  <FormGroup style={{display: image?.highlightType === HIGHLIGHT_TYPE.offer ? "block" : "none"}}>
                    <span>Preço original, sem oferta</span>
                    <CurrencyInput
                        id="originalValueStr"
                        className="form-control"
                        value={image?.product?.originalValueStr || ""}
                        name="originalValueStr"
                        decimalsLimit="2"             
                        placeholder="0,00"
                        onValueChange={(value) => onChangeOriginalValue(value)}
                    />
                  </FormGroup>
                  <FormGroup style={{display: image?.highlightType === HIGHLIGHT_TYPE.club ? "block" : "none"}}>
                    <span>Preço no clube de descontos</span>
                    <CurrencyInput
                        id="clubValueStr"
                        className="form-control"
                        value={image?.product?.clubValueStr || ""}
                        name="clubValueStr"
                        decimalsLimit="2"
                        placeholder="0,00"
                        onValueChange={(value) => onChangeClubValue(value)}
                    />
                  </FormGroup>
                </Col>
              </Row>   
              <Row>
                <Col xs={12} md={12}> 
                  <FormGroup>
                    <span>Imagem do produto</span>                      
                    <Autocomplete
                      key={imageContainer.id}
                      freeSolo
                      noOptionsText={"Nenhum"}
                      onInputChange={(event, value) =>                         
                        onInputChangeImageContainer(event, value)
                      }
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      loadingText={"Carregando"}
                      loading={imageIsLoading}
                      style={{paddingBottom: "10px"}}                                      
                      value={imageContainer}
                      id="image"
                      options={imagesContainer.map((imageContainer) => imageContainer)}
                      size="small"
                      renderInput={(params) => (
                        <TextField  {...params}  variant='standard'/>
                      )}
                      sx={autoCompleteSx()}
                      renderOption={(props, option) => (
                        <span {...props}>
                          <OptionItem option={option} />
                        </span>
                      )}                   
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={6}>
                  {!isEmptyOrNullStr(imageContainer.url) ?
                    <a target="_blank" rel="noopener noreferrer" href={imageContainer.url}> <span style={{marginLeft: "10px", color: "#525f7f", textDecoration: "underline"}}>Visualizar</span></a>
                  : (<></>)}
                </Col>
                { product?.productId > 0 && imagesContainer.length < 2 ?
                <Col xs={12} md={6}
                  style={{textAlign: "right"}}>              
                  <Button
                    className="btn-fill btn-xs"
                    color="primary"
                    type="button"
                    onClick={()=>onWebSearch()}
                  >
                    Buscar na internet
                  </Button>
                </Col>
                : (<></>)}
              </Row>
              <Row>     
                <Col style={{textAlign: "right"}}>
                  <Button
                    className="btn-fill btn-xs"
                    color="danger"
                    type="button"
                    onClick={()=>onCancel()}
                  >
                    Voltar
                  </Button>
                  <Button
                    className="btn-fill btn-xs"
                    color="primary"
                    type="submit"
                  >
                    Salvar
                  </Button>
                </Col>
              </Row>                  
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

FolderComponent.propTypes = {
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  image: PropTypes.object.isRequired
};

export default FolderComponent;